
import { reactive, ref } from "vue";
export default {
  props: {
    screeningClick: {
      type: Function,
      default: () => {},
    },
  },
  setup(props: any, { emit }: any) {
    const active = ref('1');
    const showPopover = ref(false);
    const option = [
      { text: "Top sales", value: "1" },
      // { text: "Popular", value: "2" },
      { text: "Popular", value: "0" },
      { text: "New Arrivals", value: "3" },
      
       { text: "Low to High", value: "4" },
      { text: "High to Low", value: "5" },
     
      
    ];
    const dropdownClick = (value: any) => {
      emit("screeningClick", option[value].value);
    };
    const actions = [
      { text: "Low to High", value: "4" },
      { text: "High to Low", value: "5" },
    ];
    const onSelect = (action: any) => {
      emit("screeningClick", action.value);
    };

    return {
      active,
      option,
      dropdownClick,
      onSelect,
      actions,
      showPopover,
    };
  },
};
